<template>
  <div>
    <section
      id="cropperBanner"
      class="cropper-area"
    >
      <div class="header-component">
        <div class="title-component">{{ title }}</div>
        <div
          class="close"
          @click="$emit('close-modal')"
        >
          &times;
        </div>
      </div>
      <!-- Input Hidden -->
      <input
        ref="inputImage"
        type="file"
        class="d-none"
        @change="handleFileUpload($event ,false)"
      >

      <div class="img-cropper">
        <vue-cropper
          ref="cropper"
          :src="imgUrl"
          preview=".preview"
        />
      </div>

      <!-- Edit -->
      <div class="px-4 py-3">
        <div class="wrap-setting">
          <div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <label class="m-0">Zoom</label>
              <label class="m-0">{{ zoom }}</label>
            </div>
            <b-form-input
              v-model="zoom"
              type="range"
              min="0"
              max="5"
              step="0.5"
              class="form-range p-0"
            />
          </div>

          <div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <label class="m-0">Rotate</label>
              <label class="m-0">{{ rotate }}</label>
            </div>
            <b-form-input
              v-model="rotate"
              type="range"
              min="-45"
              max="45"
              step="1"
              class="form-range p-0"
            />
          </div>
          <div
            class="btn-rotate"
            @click="rotateImage"
          >
            <img src="@/assets/icon/rotate.svg" >
          </div>
        </div>

        <div class="d-flex justify-content-end align-items-center mt-5">
          <!-- <div
            class="btn-delete-photo"
            @click="deleteImage"
          >
            Delete Photo
          </div> -->

          <div class="d-flex">
            <b-button
              class="btn gray mr-2"
              @click.prevent="changeImage"
            >
              Change Photo
            </b-button>
            <b-button
              class="btn blue"
              @click.prevent="cropImage"
            >
              Save
            </b-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VueCropper from 'vue-cropperjs';
import jMixWidgetBanner from '@/mixins/jMixWidgetBanner';
import 'cropperjs/dist/cropper.css';

export default {
  components: {
    VueCropper,
  },
  mixins: [jMixWidgetBanner],
  props: {
    url: {
      type: String,
      default: '',
      required: true,
    },
    nameFile: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      imgUrl: '',
      cropImg: '',
      data: null,
      zoom: 0,
      rotate: 0,
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['company_banner']),
  },
  watch: {
    zoom(val, prevVal) {
      if (val > prevVal) {
        const data = Number(val) - Number(prevVal);
        this.$refs.cropper.relativeZoom(data);
      } else {
        const data = Number(prevVal) - Number(val);
        this.$refs.cropper.relativeZoom(-data);
      }
    },
    rotate(val, prevVal) {
      if (val > prevVal) {
        const data = Number(val) - Number(prevVal);
        this.$refs.cropper.rotate(data);
      } else {
        const data = Number(prevVal) - Number(val);
        this.$refs.cropper.rotate(-data);
      }
    },
    cropImg(val) {
      this.uploadFile(null, this.nameUpdated || this.nameFile, val);
    },
    fileUrl(val) {
      this.setCompanyBanner(val);
    },
  },
  created() {
    if (this.url) {
      this.imgUrl = this.url;
    }
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem', 'toggleSuccess']),
    ...mapActions('jStoreApplication', ['actionSetCompanyBanner']),

    rotateImage() {
      this.$refs.cropper.rotate(90);
    },

    cropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL().split(',')[1];
    },

    changeImage() {
      this.$refs.inputImage.click();
    },

    deleteImage() {
      this.$swal({
        title: '<div style="color:#D2232A">Delete</div>',
        html: 'Are you sure to delete image',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          const payload = {
            id: this.company_banner.id,
            url_banner: '',
          };
          this.actionSetCompanyBanner(payload).then((res) => {
            if (!res.error) {
              this.$emit('save-banner');
            }
          });
        }
      });
    },

    setCompanyBanner(fileUrl) {
      const payload = {
        url_banner: fileUrl,
      };
      if (this.company_banner) {
        payload.id = this.company_banner.id;
      }
      this.actionSetCompanyBanner(payload).then((res) => {
        if (!res.error) {
          this.$emit('save-banner');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .header-component {
    padding: 1rem;
    position: relative;

    .title-component {
      font-family: 'Poppins-Bold';
      font-size: 16px;
      color: #525252;
      text-align: center;
    }
    .close {
      position: absolute;
      top: 16px;
      right: 20px;
      font-size: 24px;
      cursor: pointer;
    }
  }
  .wrap-setting {
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    grid-gap: 20px;
  }
  .btn-delete-photo {
    font-family: 'Poppins-Bold';
    font-size: 14px;
    color: #848484;
    cursor: pointer;
  }
  .btn-rotate {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
      transform: scaleX(-1);
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/cropping/jCroppingImage.vue